export default class FunctionInfoFilter {
  
  constructor () {
      this.id = "";
      this.name = "";
  }
}
